const GET_DETAIL_RTW_PRODUCT_BY_ID = 'GET_DETAIL_RTW_PRODUCT_BY_ID'
const GET_DETAIL_RTW_PRODUCT_BY_ID_SUCCESS = 'GET_DETAIL_RTW_PRODUCT_BY_ID_SUCCESS'

const PUT_RTW_PRODUCT = 'PUT_RTW_PRODUCT'
const PUT_RTW_PRODUCT_SUCCESS = 'PUT_RTW_PRODUCT_SUCCESS'

const POST_RTW_PRODUCT = 'POST_RTW_PRODUCT'
const POST_RTW_PRODUCT_SUCCESS = 'POST_RTW_PRODUCT_SUCCESS'

const GET_RTW_PRODUCT_PAGES = 'GET_RTW_PRODUCT_PAGES'
const GET_RTW_PRODUCT_PAGES_SUCCESS = 'GET_RTW_PRODUCT_PAGES_SUCCESS'


const RtwProductType = {
  GET_DETAIL_RTW_PRODUCT_BY_ID,
  GET_DETAIL_RTW_PRODUCT_BY_ID_SUCCESS,

  PUT_RTW_PRODUCT,
  PUT_RTW_PRODUCT_SUCCESS,

  POST_RTW_PRODUCT,
  POST_RTW_PRODUCT_SUCCESS,

  GET_RTW_PRODUCT_PAGES,
  GET_RTW_PRODUCT_PAGES_SUCCESS

}

export default RtwProductType
